import React from 'react';

import "../../css/main.css"

export function VisitListElement(visitData, currentYear) {

    return (
        <>


            <div className='formbox'>

                <div className='formtitle'>Visits for {currentYear} ({visitData.length})</div>
                <div className='gridrow'>
                    <div className='gridcolumn'>Visit Date</div>
                    <div className='gridcolumn'>Comment</div>
                </div>
                {visitData.map((visit) => (
                    <div key={visit.visit_date} className='gridrow'>
                        <div className='gridcell'>{visit.formatted_date}</div>
                        <div className='gridcell'>{visit.comment}</div>
                    </div>
                ))}

            </div>



        </>

    );
}